import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import CompactLayout from 'src/layouts/compact';
import StandaloneLayout from 'src/layouts/standalone';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const TrackShipmentPage = lazy(() => import('src/pages/track'));
const DistributorTrackingPage = lazy(() => import('src/pages/distributor-tracking'));
const TermsAndConditionsPage = lazy(() => import('src/pages/legal/terms-and-conditions'));
const PrivacyPolicyPage = lazy(() => import('src/pages/legal/privacy-policy'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [{ path: '404', element: <Page404 /> }],
  },
  {
    element: (
      <StandaloneLayout>
        <Outlet />
      </StandaloneLayout>
    ),
    children: [
      { path: 'track', element: <TrackShipmentPage /> },
      { path: 'delivery-tracking', element: <DistributorTrackingPage /> },
      { path: 'terms-and-conditions', element: <TermsAndConditionsPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
    ],
  },
];
